<template lang="pug">
  .card
    .card-header
      .grid-container
        .grid-item(v-for="(field, index) in mappedFields" :key="index")
          .field-name {{ field.name }}
          .field-value  {{ formatValue(field) }}
    .card-body
      .accordion
        .accordion-header(@click="toggleAccordion")
          span Ver histórico de alterações
          .icon
            i.fas.fa-arrow-down(v-if="!isAccordionOpen")
            i.fas.fa-arrow-up(v-if="isAccordionOpen")
        .accordion-body(v-show="isAccordionOpen")
            div(v-if="alteracoes.length > 0")
                .timeline
                    .timeline-item(v-for="(change, index) in changes" :key="index")
                        .timeline-icon
                        .timeline-content
                            p {{ change }}

            div(v-else)
                p Nenhuma alteração feita ainda.
</template>

<script>
export default {
    props: {
        dadosAnalise: {
            type: Object,
            required: false
        },
        changes: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            isAccordionOpen: false,
            alteracoes: [],
            mappedFields: [
                { name: 'Id do processo', value: this.dadosAnalise?.idProcesso },
                { name: 'Aprovação prada?', value: this.dadosAnalise?.aprovacaoPrada ? 'Sim' : 'Não' },
                { name: 'Retificação solicitada?', value: this.dadosAnalise?.retificacaoSolicitada ? 'Sim' : 'Não' },
                { name: 'Documentos solicitados?', value: this.dadosAnalise?.documentosSolicitados ? 'Sim' : 'Não' },
                { name: 'Status', value: this.dadosAnalise?.status ? 'APROVADA' : 'REPROVADA' },

                { name: 'Data da Vinculação Técnica', value: this.dadosAnalise?.dtVinculacaoTecnica},
                { name: 'Data de Início da Análise', value: this.dadosAnalise?.dtInicioAnaliseTecnica},
                { name: 'Data do Fim da Análise', value: this.dadosAnalise?.dtFimAnaliseTecnica},
                { name: 'Data da validação pelo GO', value: this.dadosAnalise?.dtValidacaoGO},
                { name: 'Duração da Análise', value: this.dadosAnalise?.duracaoAnalise + ' dias' },
                { name: 'Duração da Validação', value: this.dadosAnalise?.duracaoTotal + ' dias'},
                { name: 'Justificativa da reprovação', value: this.dadosAnalise?.justificativa },
            ],
        };
    },
    methods: {
        toggleAccordion() {
            this.isAccordionOpen = !this.isAccordionOpen;
        },

        isDateField(fieldName) {
            return ['Data da Vinculação Técnica', 'Data de Início da Análise', 'Data do Fim da Análise', 'Data da validação pelo GO'].includes(fieldName);
        },
        formatValue(field) {
            if (this.isDateField(field.name)) {
                if (field.value)
                    return new Date(field.value).toLocaleDateString();
                else
                    return 'Data Inválida';
            }
            return field.value;
        }
    }
};
</script>

<style scoped>
.card {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 0px;
}
.card-header {
    padding-bottom: 10px;
}
.grid-container {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 10px;
}
.grid-item {
    padding: 10px;
    text-align: left;
}
.field-name {
    font-weight: bold;
    margin-bottom: 5px;
    color: #888;
}
.field-value {
    font-size: 14px;
    color: #555;
}
.card-body {
     padding-top: 10px;
}
.accordion-header {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    padding: 5px 0;
    font-weight: bold;
}
.accordion-body {
    overflow: hidden;
    transition: height 0.3s ease;
}
.timeline {
    list-style: none;
    padding: 0;
    position: relative;
}
.timeline-item {
    position: relative;
    margin: 0px; /* Aumenta o espaço entre os itens */
    padding-left: 5px;
}
.timeline-item::before {
    content: '';
    position: absolute;
    top: 5px;
    left: 6px;
    width: 2px;
    height: 20px;
    background: #ddd;
}
.timeline-item:last-child::before {
    top: 0;
    bottom: 0; /* Termina na parte inferior */
}
.timeline-icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 10px;
    height: 10px;
    background: #fff;
    border: 2px solid #007bff;
    border-radius: 50%;
    z-index: 1;
}
.timeline-content {
    margin-left: 30px;
}
.icon i {
    font-size: 18px;
}
</style>
